import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFlag = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.75 2h13.5a.75.75 0 0 1 .556 1.253L15.762 7.73l4.046 4.478a.75.75 0 0 1-.557 1.252H6.5v7.789a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 5.75 2m.75 9.962h11.062l-3.369-3.728a.75.75 0 0 1 0-1.006L17.563 3.5H6.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgFlag;
